import { SharedDocumalisModule } from '@documalis/shared-documalis.module';
import { NgModule } from '@angular/core';
import { DelegateRoutes } from './delegate.routes';
import { ListDelegateComponent } from './list-delegate/list-delegate.component';
import { FormDelegateComponent } from './_components/form-delegate/form-delegate.component';
import { AddDelegateComponent } from './add-delegate/add-delegate.component';
import { EditDelegateComponent } from './edit-delegate/edit-delegate.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [DelegateRoutes, SharedDocumalisModule, TranslateModule],
    declarations: [ListDelegateComponent, AddDelegateComponent, EditDelegateComponent, FormDelegateComponent],
})
export class DelegateModule {}
